import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  withDefaults,
  defineProps,
  defineEmits,
} from "../TUIKit/adapter-vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { TUICallKit } from "@tencentcloud/call-uikit-vue2";
import {
  TUIChat,
  TUIConversation,
  TUIContact,
  TUIGroup,
  TUISearch,
} from "../TUIKit";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import NavBar from "../components/NavBar.vue";
import Profile from "./Profile.vue";
import ChatDefaultContent from "../components/ChatDefaultContent.vue";
import Drag from "../TUIKit/components/common/Drag";
import { isPC, isH5 } from "../TUIKit/utils/env";
import { enableSampleTaskStatus } from "../TUIKit/utils/enableSampleTaskStatus";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  props: {
    language: { default: "zh" }
  },
  emits: ["changeLanguage"],
  setup(__props: any, { emit: emits }) {

const props = __props as { language: string }



const locale = ref<string>(props.language);
const isMenuShow = ref<boolean>(true);
const currentNavBar = ref<string>("message");
const currentConversationID = ref<string>("");
const isCalling = ref<boolean>(false);
const isMinimized = ref<boolean>(false);
const dragRef = ref<typeof Drag>();
const isSettingShow = ref<boolean>(false);

function changeLanguage(language: string) {
  emits("changeLanguage", language);
}
TUIStore.watch(StoreName.CONV, {
  currentConversationID: (id: string) => {
    currentConversationID.value = id;
  },
});
function toggleMenu(value: boolean) {
  isMenuShow.value = value;
}

function beforeCalling() {
  isCalling.value = true;
  enableSampleTaskStatus("call");
}

function afterCalling() {
  isCalling.value = false;
  isMinimized.value = false;
}

function onMinimized(oldMinimizedStatus: boolean, newMinimizedStatus: boolean) {
  isMinimized.value = newMinimizedStatus;
  dragRef?.value?.positionReset();
}
function toggleSettingShow(value: boolean) {
  isSettingShow.value = value;
}
function switchNavBar(value: string) {
  currentNavBar.value = value;
}

return { __sfc: true,props, emits, locale, isMenuShow, currentNavBar, currentConversationID, isCalling, isMinimized, dragRef, isSettingShow, changeLanguage, toggleMenu, beforeCalling, afterCalling, onMinimized, toggleSettingShow, switchNavBar, TUICallKit, TUIChat, TUIConversation, TUIContact, TUIGroup, TUISearch, NavBar, Profile, ChatDefaultContent, Drag, isPC, isH5 }
}

})